module.exports = __webpack_public_path__ + "static/media/cover.eebc5185.jpg";